import {
  jobTypeSlugOptions,
  SALARY_FULL_TIME_VALUE,
} from '../surveys/configs/onboarding/current-job-pane-config'

const vowels = ['a', 'e', 'i', 'o', 'u']

function getJobType(jobType?: string | null | undefined) {
  // SALARY_FULL_TIME_VALUE = '-'. This is a salary seo url specific \
  // value. We should not mix '-' or 'fullTime'. '-' should only be
  // used in the URL.
  return jobType !== SALARY_FULL_TIME_VALUE
    ? jobTypeSlugOptions.find(({ id }) => id === jobType)?.label
    : undefined
}

function getLocationText(location?: string) {
  return location ? `in ${location}` : undefined
}

export function getSalarySeoH1({
  occupation,
  location,
  jobType,
}: {
  occupation?: string
  location?: string
  jobType?: string | null | undefined
}) {
  return getSalarySeoTitle({
    occupation,
    location: location ?? 'US',
    jobType,
    hideSalaryUpdatedAt: true,
  })
}

export function getSalarySeoTitle({
  occupation,
  location,
  jobType,
  salaryUpdatedAt,
  hideSalaryUpdatedAt,
}: {
  occupation?: string
  location?: string
  jobType?: string | null | undefined
  salaryUpdatedAt?: string
  hideSalaryUpdatedAt?: boolean
}) {
  return [
    getJobType(jobType),
    occupation,
    'Salary',
    getLocationText(location),
    salaryUpdatedAt && !hideSalaryUpdatedAt
      ? `(${salaryUpdatedAt})`
      : undefined,
  ]
    .filter(Boolean)
    .join(' ')
}

export function getSalarySeoMetaDescription({
  occupation,
  location,
  jobType,
  annualSalary,
  hourlySalary,
}: {
  occupation?: string
  location?: string
  jobType?: string
  annualSalary?: string
  hourlySalary?: string
}) {
  function getArticleText(jobTypeText?: string, occupation?: string) {
    if (jobTypeText) {
      return 'a'
    }

    if (vowels.some((char) => occupation?.toLowerCase()?.startsWith(char))) {
      return 'an'
    }
    return 'a'
  }

  const suffix = 'Get paid what you’re worth!'
  const jobTypeText = getJobType(jobType)
  const articleText = getArticleText(jobTypeText, occupation)

  return [
    'The average salary for',
    articleText,
    jobTypeText,
    occupation,
    getLocationText(location),
    annualSalary ? `is ${annualSalary} per year.` : undefined,
    !annualSalary && hourlySalary ? `is ${hourlySalary} per hour.` : undefined,
    suffix,
  ]
    .filter(Boolean)
    .join(' ')
}
